/*
 * @Author       : Duanjiaojiao
 * @Date         : 2023-06-02 11:38:10
 * @LastEditors  : Duanjiaojiao
 * @LastEditTime : 2023-06-26 17:03:40
 * @Description  : 高德【我的】页面
 * @FilePath     : /BM-Main/src/apiData/gaode.js
 */
import httpClient from '@/utils/http'
import { zzHost } from '@/conf/hosts.conf'

const API = {
  getMyCenterPage: `${zzHost}/zzopen/zzbmlogic/getMyCenterPage`,
  gaoDeLogin: `${zzHost}/zzopen/passport/gaodelogin`
}

// 个人中心
export const getMyCenterPageAjax = (params) => {
  return httpClient.get(API.getMyCenterPage, params).then((data) => data)
}

// 高德静默登录
export const gaodeLoginAjax = (params) => {
  return httpClient.post(API.gaoDeLogin, params).then((data) => data)
}
